import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const AddCategoryPage = () => {
  const { countryCityId } = useParams();
  const navigate = useNavigate();

 const [getCityName, setCityName] = useState("");
  const [getCategoryName, setCategoryName] = useState("");
    const [getCategorySlag, setCategorySlag] = useState("");

      const [getCategoryMeta_title, setCategoryMeta_title] = useState("");
        const [getCategoryMeta_desc, setCategoryMeta_desc] = useState("");
          const [getCategoryMeta_keyword, setCategoryMeta_keyword] = useState("");
            const [getCategoryPage_desc, setCategoryPage_desc] = useState("");
const [loadCountrys, setCountrys] = useState([]);
const [loadCitty, setCitty] = useState([]);
  // =========================
  // FETCH SINGLE CATEGORY
  // =========================
  const fetchCategoryById = async () => {
    try {
      const res = await api.get(`/adminVisaAssistanc/getCountryCityById/${countryCityId}`);

      if (res.data.success) {
        const data = res.data.data;
        setCategoryName(data.country_slug);
          setCityName(data.city_slug);
        setCategorySlag(data.slug);
        setCategoryMeta_title(data.meta_title);
        setCategoryMeta_desc(data.meta_desc);
        setCategoryMeta_keyword(data.meta_keyword);
        setCategoryPage_desc(data.page_desc);

      } else {
        toast.error("Country City Name not found");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch Country City Name");
    }
  };

  useEffect(() => {
    if (countryCityId) {
      fetchCategoryById();
      fetchCountryData();
      fetchCityData();
    }
  }, [countryCityId]);


  const fetchCountryData = async () => {
    try {
      const res = await api.get("/adminVisaAssistanc/loadCountryData");
      setCountrys(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Country data");
    }
  };
  
  const fetchCityData = async () => {
    try {
      const res = await api.get("/adminVisaAssistanc/loadCityData");
      setCitty(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Country data");
    }
  };
// useEffect(() => {
//   const slugData = getCategoryName
//     .toLowerCase()
//     .trim()
//     .replace(/[^\w\s-]/g, "")
//     .replace(/\s+/g, "-");

//   setCategorySlag(slugData);
// }, [getCategoryName]);

  // =========================
  // UPDATE CATEGORY
  // =========================
  const updateCategory = async () => {
    if (!getCategoryName) {
      toast.error("Country City Name required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Update Country City Name?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Update"
    });

    if (!confirm.isConfirmed) return;

    try {
      const payload = {
        cat_id: countryCityId,
        category: getCategoryName,
        cityName:getCityName,
        slug :getCategorySlag,
        meta_title: getCategoryMeta_title,
        meta_desc: getCategoryMeta_desc,
        meta_keyword: getCategoryMeta_keyword,
        page_desc: getCategoryPage_desc,
      };

      const res = await api.put(
        `/adminVisaAssistanc/updateCountryCity/${countryCityId}`,
        payload
      );

      if (res.data.success) {
        Swal.fire("Success", "Country City Name Updated", "success");
        navigate("/country-city/manage-country-city-name");
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Server Error");
    }
  };

useEffect(() => {
  if (getCategoryName && getCityName) {
    const slug = `${getCategoryName}-assistance-in-${getCityName}`
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");

    setCategorySlag(slug);
  }
}, [getCategoryName, getCityName]);



  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm mb-4 bg-primary-subtle">
        <div className="card-body d-flex justify-content-between">
          <h4>Edit Country City Name</h4>

          <Link to="/country-city/manage-country-city-name" className="btn btn-secondary btn-sm">
            <ArrowLeft size={16} /> Back
          </Link>
        </div>
      </div>

      {/* FORM */}
      <div className="card">
        <div className="card-body">

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Country Name</th>
                <th>City Name</th>
              </tr>
            </thead>

            <tbody>

                <tr >
                  <td>
                       <select
          className="form-control"
          value={getCategoryName}
        onChange={(e) => { setCategoryName(e.target.value); }}
        >
          <option value="">
            -- Select Country --
          </option>

          {loadCountrys.map((cat) => (
            <option
              key={cat.cntry_id}
              value={cat.slug}
            >
              {cat.name}
            </option>
          ))}
        </select>
                  </td>

                  <td>
                    <select
          className="form-control"
          value={getCityName}
              onChange={(e) => { setCityName(e.target.value); }}
        >
          <option value="">
            -- Select City --
          </option>

          {loadCitty.map((cit) => (
            <option
              key={cit.city_id}
              value={cit.slug}
            >
              {cit.name}
            </option>
          ))}
        </select>
                  </td>
                </tr>
                
       
            </tbody>
            <thead>
             <tr>
                <th colSpan={2}>Slug</th>
              </tr>
              </thead>
              <tbody>

                <tr >
                 

                  <td colSpan={2}>
                    <input
                      className="form-control"
                      readOnly
                      value={getCategorySlag}
                      onChange={(e) =>
                        setCategorySlag(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
       
            </tbody>
              <thead>
              <tr>
                <th>   <div className="d-flex align-items-center gap-2">
                        <span>Meta Title</span>
                        <small className={`d-block mt-1 ${
                           (getCategoryMeta_title?.length || 0) > 80 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getCategoryMeta_title?.length || 0)}/80 Characters)
                        </small>
                     </div></th>
                <th>
                     <div className="d-flex align-items-center gap-2">
                        <span>Meta Description</span>
                        <small className={`d-block mt-1 ${
                           (getCategoryMeta_desc?.length  || 0)> 160 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getCategoryMeta_desc?.length || 0)}/160 Characters)
                        </small>
                     </div>
                </th>
              </tr>
            </thead>
            
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" className="form-control" maxLength={80} value={getCategoryMeta_title} onChange={(e) => setCategoryMeta_title(e.target.value)} />
                     {(getCategoryMeta_title?.length || 0) >= 79 && (getCategoryMeta_title?.length || 0) <= 80 && (
                     <small className="text-danger">
                     ⚠️ Almost reached limit
                     </small>
                     )}
                  </td>

                  <td>
                   <textarea className="form-control"  rows="3"  maxLength={160} value={getCategoryMeta_desc} onChange={(e) => setCategoryMeta_desc(e.target.value)} />
               {(getCategoryMeta_desc?.length || 0 )>= 159 && (getCategoryMeta_desc?.length || 0) <= 160 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                  </td>
                </tr>
                
       
            </tbody>
             <thead>
              <tr>
                <th>
                     <div className="d-flex align-items-center gap-2">
               <span>Meta Keyword  </span><small className={`d-block mt-1 ${
                  (getCategoryMeta_keyword?.length || 0 )> 255 ? "text-danger" : "text-muted"
               }`}>
               ({(getCategoryMeta_keyword?.length || 0 )}/255 Characters)
               </small>
               </div>
                </th>
                <th>Page Description</th>
              </tr>
            </thead>
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" maxLength={255} className="form-control" value={getCategoryMeta_keyword} onChange={(e) => setCategoryMeta_keyword(e.target.value)} ></textarea>
               {(getCategoryMeta_keyword?.length || 0)>= 254 && (getCategoryMeta_keyword?.length || 0) <= 255 && (
               <small className="text-danger">
               ⚠️ Almost reached limit
               </small>
               )}
                  </td>

                  <td>
                    <textarea
                  rows="3"
                      className="form-control"
                      
                      value={getCategoryPage_desc}
                      onChange={(e) =>
                        setCategoryPage_desc(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
       
            </tbody>
          </table>

          <button className="btn btn-success mt-3" onClick={updateCategory}>
            Update Country City Name
          </button>

        </div>
      </div>
    </div>
  );
};

export default AddCategoryPage;